import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  card: null,        
  amount: null,
  // details: {},
  purchaseResult: null,
  loading: false,
  error: null,
  purchaseToken: null, 
};

const slice = createSlice({
  name: "giftCardCheckout",
  initialState,
  reducers: {
    setCard: (state, action) => { state.card = action.payload; },
    setAmount: (state, action) => { state.amount = action.payload; },
    // setDetails: (state, action) => { state.details = action.payload; },
    setPurchaseResult: (state, action) => { state.purchaseResult = action.payload; },
    setLoading: (state, action) => { state.loading = action.payload; },
    setError: (state, action) => { state.error = action.payload; },
    setPurchaseToken: (state, action) => { state.purchaseToken = action.payload; }, 
    resetCheckout: () => initialState,
  }
});

export const {
  setCard,
  setAmount,
  // setDetails,
  setPurchaseResult,
  setLoading,
  setError,
  setPurchaseToken,
  resetCheckout,
} = slice.actions;

export default slice.reducer;
